import {useGoogleLogin} from "@react-oauth/google";
import {userLogin} from "@/store/actions/auth.action.ts";
import {useDispatch} from "react-redux";
import axios from "axios";
import {CommonService} from "@/services";
import {GoogleIconLogo} from "@/constants/ImageConfig.ts";
import {Button} from "@/components/ui/button.tsx";
import {useSocket} from "@/services/hooks/useSocket.ts";
import {useQueryClient} from "@tanstack/react-query";
import {useState} from "react";
import {ENV} from "@/constants";

const SOCKET_URL = ENV.SOCKET_URL;



const GoogleLoginComponent = () => {
    const dispatch = useDispatch()
    const {connect} = useSocket({
        eventTypes: ['auth_success'],
        projectId: "" // Empty string for auth-related socket connection
    });
    const queryClient = useQueryClient();
    const [isLoadingInProgress, setIsLoadingInProgress] = useState(false);


    const login = useGoogleLogin({
        onSuccess: async (codeResponse) => {
            
            await axios
                .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${codeResponse.access_token}`, {
                    headers: {
                        Authorization: `Bearer ${codeResponse?.access_token}`,
                        Accept: 'application/json'
                    }
                })
                .then(async () => {
                    setIsLoadingInProgress(true)
                    const payload = {
                        token: codeResponse?.access_token
                    }
                    await CommonService._account.GoogleLoginAPICall(payload)
                        .then((response: any) => {
                            // Track successful Google login/signup
                            if(response?.data?.user?.is_signup){
                                CommonService.handleMixpanelTrack("Google Signup Success", {
                                    user_id: response?.data?.user?.id,
                                    email: response?.data?.user?.email,
                                    name: response?.data?.user?.name,
                                    timestamp: new Date().toISOString()
                                });
                            }
                            else{
                            CommonService.handleMixpanelTrack("Google Login Success", {
                                user_id: response?.data?.user?.id,
                                email: response?.data?.user?.email,
                                name: response?.data?.user?.name,
                                is_new_user: response?.data?.is_new_user || false,
                                timestamp: new Date().toISOString()
                            });
                            }
                            
                            const token = response?.data?.token;
                            if (SOCKET_URL) {
                                connect(SOCKET_URL, token);
                            }
                            queryClient?.invalidateQueries();
                            dispatch(userLogin(response?.data?.user, response?.data?.token || "", "username"));
                            }
                        )
                })
                .catch((err) => {
                    // Track Google login failure
                    CommonService.handleMixpanelTrack("Google Login Failed", {
                        error: err?.message || "Unknown error",
                        timestamp: new Date().toISOString()
                    });
                })
                .finally(() => {
                    setIsLoadingInProgress(false)
                });
        },
        onError: (error) => {
            // Track Google login error
            CommonService.handleMixpanelTrack("Google Login Error", {
                error: error?.error || "Unknown error",
                timestamp: new Date().toISOString()
            });
        }
    });


    return (
        <div className="google-btn mt-3 mb-4">
            <Button
                onClick={() => {
                    // Track Google login button click
                    CommonService.handleMixpanelTrack("Google Login Button Clicked", {
                        timestamp: new Date().toISOString()
                    });
                    login();
                }} 
                fullWidth={true}
                size={"lg"}
                variant={"outline"}
                color={"secondary"}
                loading={isLoadingInProgress}
            >
                <GoogleIconLogo/> Continue with Google
            </Button>
        </div>
    );

};

export default GoogleLoginComponent;
